import React from 'react';
import { ClickableTile } from 'carbon-components-react';
import { ArrowRight16 } from '@carbon/icons-react';
import messages from '../../../locales/messages';
import Cta from '../../Molecules/Cta/Cta';
import { getMessage } from 'src/common/hooks/widgets/useLang';
import './Welcome.scss';
import C4DVideoPlayerContainer from '@carbon/ibmdotcom-web-components/es/components-react/video-player/video-player-container';
import { createUseTranslation } from 'src/common/hooks/widgets/useTranslation';
import { useQradarEDRSelector } from '../../../lib/redux/hooks';
import * as VideosIDs from '../../../constants/default';
import { segmentsTracking } from 'src/common/lib/tracker';
import { shortcode } from '../../../aisolutionsadvisor.widget';

type WelcomeProps = {
  handleLaunchModal: () => void;
  modal2: boolean;
  setModal2: React.Dispatch<React.SetStateAction<boolean>>;
  modalBtnLangText: string;
  toggleCountry: boolean;
  localExist: boolean;
  flag: boolean;
};

const Welcome = ({
  handleLaunchModal,
  setModal2,
  modalBtnLangText,
  toggleCountry,
  localExist,
  flag,
}: WelcomeProps) => {
  const AEMMessages = useQradarEDRSelector(
    (state) => state.translations.messages,
  );
  const useTranslation = createUseTranslation(messages, AEMMessages);
  const picture = 'images/demo.png';
  const thumbnail = `${
    process.env.PUBLIC_ASSETS_URL || process.env.STORYBOOK_PUBLIC_ASSETS_URL
  }/${shortcode}/${picture}`;
  return (
    <section className="welcome">
      <div className="bx--row">
        <div className="bx--col-lg-8 bx--col-md-4 bx--col-sm-2 videoContainer">
          <div className="bx--row">
            <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
              <C4DVideoPlayerContainer
                aspectRatio="16x9"
                playing-mode="inline"
                hide-caption={true}
                video-description=""
                thumbnail={thumbnail}
                videoId={VideosIDs.videoId_welcome}
                onClick={() => {
                  segmentsTracking('CTA Clicked', {
                    pageTitle: 'AI Solutions Advisor',
                    object: 'AI Solutions Advisor page',
                    resultValue: 'CTA clicked',
                    CTA: 'Introduction video launched',
                    location: 'Main widget page',
                    action: `Launched media video`,
                    field: '',
                  });
                }}
              />
            </div>
          </div>
        </div>
        <div className="bx--col-lg-8 bx--col-md-4 bx--col-sm-2 mar1">
          <div className="bx--row">
            <div className="bx--col-lg-15 bx--col-md-7 bx--col-sm-3">
              <div className="bx--row">
                <div className="welcome_heading">
                  {useTranslation('welcome_title')}{' '}
                  {useTranslation('welcome_subtitle')}
                </div>
              </div>
              <div className="bx--row">
                <div className="welcome_subheadign">
                  {useTranslation('welcome_paragraph')}
                </div>
              </div>
              <div className="bx--row">
                {flag && localExist && toggleCountry && (
                  <Cta
                    value={`${getMessage(
                      messages.welcome_accessPageCapitalized,
                    )} ${modalBtnLangText}`}
                    handleClick={() => setModal2(true)}
                    kind="tertiary"
                    iconType="arrow"
                    classes="welcome_CTA"
                  />
                )}
              </div>
            </div>
            <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
              <div className="bx--row mar2"></div>
              <div className="bx--row mar2"></div>
              <div className="bx--row mar2"></div>
              <div className="bx--row button_location">
                <ClickableTile
                  id="clickabel-tile-01"
                  className="welcome_tile"
                  role="button"
                  onClick={() => {
                    handleLaunchModal();
                  }}
                >
                  <div className="welcome_tile_text">
                    {useTranslation('welcome_CTA01')}
                    <ArrowRight16 className="welcome_tile_arrow" />
                  </div>
                </ClickableTile>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Welcome;
